module.exports = __webpack_public_path__ + "static/media/door0203.d758b4bd.jpg";